var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4b233;\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,0c70.69,0,134.69,28.66,181.02,74.98,46.33,46.33,74.98,110.33,74.98,181.02s-28.66,134.69-74.98,181.02c-46.33,46.33-110.33,74.98-181.02,74.98s-134.69-28.66-181.02-74.98C28.66,390.69,0,326.69,0,256S28.66,121.31,74.98,74.98C121.31,28.66,185.31,0,256,0ZM275.55,302.28c-.88,22.06-38.25,22.09-39.1,0-3.78-37.8-13.44-127.55-13.14-163.07.31-10.95,9.38-17.43,20.99-19.9,3.58-.76,7.51-1.14,11.48-1.13,3.99,0,7.93.4,11.51,1.17,11.99,2.55,21.4,9.3,21.4,20.44l-.04,1.12-13.1,161.38ZM256,341.49c14.45,0,26.17,11.72,26.17,26.17s-11.71,26.17-26.17,26.17-26.17-11.71-26.17-26.17,11.72-26.17,26.17-26.17ZM256,29.46c125.11,0,226.54,101.42,226.54,226.54s-101.42,226.54-226.54,226.54S29.46,381.11,29.46,256,130.89,29.46,256,29.46h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.35831eac1f03cbfecb1b7a3d3aacf7cc.svg";
export { ForwardRef as ReactComponent };